

















import { Component, Prop, Vue } from "vue-property-decorator";
import { ITag } from "@/models/tags";

@Component({
  components: {
    "tags-cloud-view": () =>
      import("@/components/app/global/tags/tagsCloudView.vue")
  }
})
export default class TagsFilter extends Vue {
  @Prop({ required: true })
  public value!: ITag["id"][];

  @Prop({ required: true })
  public tags!: ITag[];

  @Prop({ default: false })
  public disabled!: boolean;

  public selectedTags: ITag[] = [];

  public created() {
    this.selectedTags = this.$_.filter(this.tags, tag =>
      this.value.includes(tag.id)
    );
  }

  public toggle(tag: ITag) {
    const isSelected = this.selectedTags.includes(tag);

    if (!isSelected) {
      this.selectedTags.push(tag);
    } else {
      // Reactivity is lost when used with some lodash functions like _.remove
      const index = this.selectedTags.indexOf(tag);
      this.selectedTags.splice(index, 1);
    }
    this.$emit("input", this.selectedTags);
  }
}
